@let attendeeView = getAttendeeView(poll);
<div class="poll-header">
	<p class="poll-question">{{ poll.question }}</p>
</div>
@if (poll.isOpen) {
	<div>
		@if (poll.multipleChoice) {
			<div>
				@for (answer of poll.answers; track $index; let i = $index; let isFirst = $first) {
					<vb-ui-checkbox class="poll-responses" [name]="cardIndex + '-' + i + '-answerChkBox'" [accessibilityLabel]="answer.text" [autoFocus]="isFirst" [(ngModel)]="answer.checked" (ngModelChange)="onAnswerClick(answer)">
						<span class="text-break">{{ answer.text }}</span>
					</vb-ui-checkbox>
				}
			</div>
		} @else {
			<vb-radio-group-btn [ngModel]="poll.selectedAnswer">
				@for (answer of poll.answers; track $index; let i = $index; let isRadioFirst = $first) {
					<vb-radio-btn class="poll-responses" [accessibilityLabel]="answer.text" [autoFocus]="isRadioFirst" [name]="cardIndex + '-' + i + '-answerRadioBtn'" [optionValue]="answer.text" (changed)="onAnswerClick(answer)">
						<span class="text-break">{{ answer.text }}</span>
					</vb-radio-btn>
				}
			</vb-radio-group-btn>		
		}
	</div>
}

@if (poll.isPublished && !poll.multipleChoice) {
	<div class="view-toggles">
		<button type="button" class="toggle-btn" [class.active]="attendeeView === PollGraphType.BAR" (click)="setBarGraph()" [attr.aria-label]="'Bar_Chart' | translate" [title]="'Bar_Chart' | translate">
			<span class="vb-icon vb-icon-barchart-horizontal-nofill"></span>
		</button>
		<button type="button" class="toggle-btn" [class.active]="attendeeView === PollGraphType.PIE" (click)="setPieGraph()" [attr.aria-label]="'Pie_Chart' | translate" [title]="'Pie_Chart' | translate">
			<span class="vb-icon vb-icon-piechart-nofill"></span>
		</button>
	</div>
}

@if (attendeeView === PollGraphType.BAR) {
	<div class="poll-options">
		@for (answer of poll.answers; track $index) {
			<div class="option-bar">
				<div class="fill-bar" [style.width]="getPercent(answer)"></div>
				<span class="option-label">{{ answer.text }}</span>
				<span class="option-stat">
					{{ getPercent(answer) }}
				</span>
			</div>
		}
	</div>
} @else if(attendeeView === PollGraphType.PIE) {
	@if (poll.totalResponses > 0) {
		<vb-ui-pie-chart flex="fill" class="pie-chart" categoryField="text" [disableLegendToggle]="true" [internalLabels]="true" [updateEnabled]="true" [data]="poll.answers" [bottomLegend]="true" [scrollableLegend]="true" [outline]="true" valueField="count" [legendCssClass]="'legend-output'">
		</vb-ui-pie-chart>
	} @else {
		<span class="d-flex justify-content-center">{{ 'UI_Chart_NoDataAvailable' | translate }}</span>
	}
}

@if (poll.isOpen) {
	<div class="poll-footer">
		<div class="poll-response-footer" [class]="poll.responseSubmitted ? 'justify-content-between' : 'justify-content-end'">
			<div [hidden]="!poll.responseSubmitted">
				{{ 'Event_Response_Submitted' | translate }}
			</div>
			<button type="button" vbBtnPrimary (click)="vote()" [disabled]="!enablePollSubmit">
				{{ 'UI_Submit' | translate }}
			</button>
		</div>
	</div>
}
